import { Injectable } from '@angular/core';
import { DataIndexClientService } from '@mode/queries/schemas/data-access';
import { ColumnsInfo, PinnedTable, SchemaListUpdate, Table, TablesUpdate } from '@mode/shared/contract-common';
import { iconClassFromColumnType } from '@mode/shared/util-js';
import { AlphabeticalSchemasFacade } from './alphabetical-schemas-facade.interface';

@Injectable({ providedIn: 'root' })
export class DataIndexSchemasFacade implements AlphabeticalSchemasFacade {
  constructor(private dataIndexClientService: DataIndexClientService) {}

  public getSchemaListUpdate(page: number, dataSourceToken: string): Promise<SchemaListUpdate> {
    return this.dataIndexClientService.getSchemas(dataSourceToken, page);
  }

  public getPageOfTables(page: number, dataSourceToken: string, schemaId: string): Promise<TablesUpdate> {
    return this.dataIndexClientService.getTables(dataSourceToken, schemaId, page);
  }

  public getFirstPageOfTables(dataSourceToken: string, schemaId: string): Promise<TablesUpdate> {
    return this.dataIndexClientService.getSchema(dataSourceToken, schemaId);
  }

  private getTable(dataSourceToken: string, schemaId: string, tableId: string): Promise<Table> {
    return this.dataIndexClientService.getTable(dataSourceToken, schemaId, tableId);
  }

  public getTablePreview(dataSourceToken: string, table: Partial<Table>): Promise<ColumnsInfo> {
    return this.getTable(dataSourceToken, table.schema || '', table.objectID || '').then((table) => {
      const preview: ColumnsInfo = {
        columns:
          table.columns != null
            ? table.columns.map((column: any) => {
                if (typeof column === 'string') {
                  column = { name: column };
                }
                column.type = column.type || column.dataType;
                column.typeClass = iconClassFromColumnType(column.type);
                return column;
              })
            : [],
      };

      return preview;
    });
  }

  parseFullNameIntoSchemaAndName(fullName: string): { schema: string; name: string } {
    const piecesOfTheFullName = fullName.split('/');

    if (piecesOfTheFullName.length === 2) {
      const [schema, name] = piecesOfTheFullName;
      return { schema, name };
    } else {
      const [_version, schema, name] = piecesOfTheFullName;

      return { schema, name };
    }
  }

  convertTableToPinId(dataSourceToken: string, table: Partial<Table & PinnedTable>) {
    return table.id || `${dataSourceToken}-${table.objectID}`;
  }

  parseIdIntoObjectID(id: string) {
    const [_dataSourceToken, nodeId] = id.split('-');

    return nodeId;
  }
}
